import { compact, isEmpty } from 'lodash-es';
import { BusinessBannerConfig } from './type';

const ALL_CHANNEL_TAG = 'all';
/** 获取展示的商户列表 */
const getSpIdList = (originalData?: { spIdList: string }): string[] => compact(originalData?.spIdList?.split('|'));

/** SPID列表类型 */
export enum SpIdListType {
  /** 白名单 */
  white = '0',
  /** 黑名单 */
  black = '1',
}

/**
 * 检查商户列表配置是否是黑名单
 */
const checkIfBlack = (spIdListType?: SpIdListType) => spIdListType === SpIdListType.black;

/**
 * 根据spid过滤banner
 * 从banner的statClick传spid, 或者，是全商户渠道banner
*/
export const filterBannerBySpid = (list: BusinessBannerConfig[], spId: string) => list.filter((item) => {
  const spIdList = getSpIdList(item.originalData);
  // 新逻辑-支持单个投放计划可以配置多个商户spId
  if (!isEmpty(spIdList)) {
    const isBlack = checkIfBlack(item.originalData?.spIdListType);
    if (isBlack && !spIdList.includes(ALL_CHANNEL_TAG)) {
      // 黑名单模式下，对在黑名单的spid不展示banner；忽略标签为all的时候的处理
      return !spIdList.includes(spId);
    }
    // 否则 就是白名单模式
    return spIdList.includes(ALL_CHANNEL_TAG) || spIdList.includes(spId);
  }
  // 原逻辑-兼容目前线上投放计划
  return [ALL_CHANNEL_TAG, spId].includes(item.bannerTag as string);
});
